import { styled } from 'parkdepot-shared/theme'
import { Link } from 'react-router-dom'

export const FormContainer = styled('div', ({ $theme }) => ({
    margin: '2.4rem 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.4rem'
}))

export const InvalidPasswordWrapper = styled('div', ({ $theme }) => ({
    border: `1px solid #FE2C3E`,
    padding: '1.2rem 2rem',
    borderRadius: '14px'
}))

export const InvalidPasswordOtherWrapper = styled('div', ({ $theme }) => ({
    marginLeft: '2.6rem'
}))

export const InvalidPasswordLine = styled('div', ({ $theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.8rem',
    marginLeft: '0.8rem'
}))

export const InvalidPasswordIcon = styled<'i', { $valid: boolean; $black?: boolean }>(
    'i',
    ({ $valid, $black = false }) => ({
        marginRight: '0.8rem',
        color: $black && !$valid ? '#000' : $valid ? '#039855' : '#FE2C3E'
    })
)

export const InvalidPasswordLineTitle = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall
}))

export const InvalidPasswordText = styled<'span', { $valid: boolean; $black?: boolean }>(
    'span',
    ({ $theme, $valid, $black = false }) => ({
        ...$theme.typography.ParagraphSmall,
        color: $black && !$valid ? '#000' : $valid ? '#039855' : '#FE2C3E'
    })
)

export const InputContainer = styled<'input', { $error?: boolean }>('input', ({ $theme, $error = false }) => ({
    height: '5rem',
    padding: '1.2rem 2rem',
    width: '100%',
    border: `1px solid  ${$error ? '#FE2C3E' : '#EAECF0'}`,
    backgroundColor: $theme.colors.white,
    color: $theme.colors.black,
    outline: 'none',
    borderRadius: '2.4rem',

    '::placeholder': {
        color: '#B3BBC7'
    }
}))

export const InputPlaceholder = styled('label', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    fontWeight: 300,
    marginBottom: '4px',
    display: 'block',
    color: '#667085'
}))

export const Title = styled('div', ({ $theme }) => ({
    paddingTop: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem'
}))

export const BlackLink = styled(Link, ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    fontWeight: 300,
    color: '#000',
    marginTop: '1.6rem',
    textDecoration: 'underline #000'
}))

export const ColoredLink = styled(Link, ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 700,
    color: '#5046E8',
    textDecoration: 'underline #5046E8'
}))

export const SeePasswordIcon = styled('i', ({ $theme }) => ({
    position: 'absolute',
    right: '1.6rem',
    bottom: '1.3rem',
    fontSize: '2.4rem',
    cursor: 'pointer',
    color: $theme.colors.primary
}))

export const LinksContainer = styled('div', ({ $theme }) => ({
    textAlign: 'center',
    width: '100%',
    margin: '2.4rem 0'
}))
